

















































































































import { BankParams } from '@/store/interfaces/bankAccount';
import { DraftCompanyParams } from '@/store/interfaces/drafts';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class BankAccountInboundForm extends Vue {
  @Prop({
    required: true,
    type: Object,
    default: {},
  })
  draft!: DraftCompanyParams;

  @Prop({
    required: true,
    type: Array,
  })
  bankList!: BankParams[];

  account_types = [
    { name: 'Corriente', id: 'current', },
    { name: 'Ahorro', id: 'savings', }
  ];

  bank = {
    bank_id: '',
    account_type: '',
    account_holder: '',
    account_number: '',
  };

  contact = {
    accountant_contact: false,
    accountant_contact_name: '',
    accountant_contact_email: '',
    accountant_contact_phone: '',
  };

  get isFinancialStatements(): boolean {
    return this.contact.accountant_contact;
  }

  @Watch('draft', { deep: true, immediate: true, })
  onDraftChange(df: DraftCompanyParams): void {
    this.assignValueToContact(df);
    this.assignValueToBankAccount(df);
  }

  assignValueToBankAccount(draftCompany: DraftCompanyParams): void {
    this.bank.bank_id = String(draftCompany.bank_account.bank.id);
    this.bank.account_type = draftCompany.bank_account.account_type;
    this.bank.account_holder = draftCompany.bank_account.account_holder;
    this.bank.account_number = draftCompany.bank_account.account_number;
  }

  assignValueToContact(draft: DraftCompanyParams): void {
    if (draft.accountant_contact) {
      this.contact.accountant_contact = true;
      this.contact.accountant_contact_name = String(
        draft.accountant_contact_name
      );
      this.contact.accountant_contact_email = String(
        draft.accountant_contact_email
      );
      this.contact.accountant_contact_phone = String(
        draft.accountant_contact_phone
      );
    }
  }
}
